var TERM_CLASS = "js-open-popin";

function GlossaryController(element, popinView, terms) {
    this.element = element;
    this.popinView = popinView;
    this.terms = terms;
    this.termModel = this.getTermModelFrom(terms);
    this.bindTermsClick();
    this.renderTermViews();
}

GlossaryController.prototype.bindTermsClick = function () {
    var self = this;

    this.element.addEventListener("click", function (event) {
        var element = event.target;

        if (element.classList.contains(TERM_CLASS)) {
            self.showPopinInfoFrom(element);
        }
    });
};

GlossaryController.prototype.showPopinInfoFrom = function (termElement) {
    var infos = this.getTermInfosFrom(termElement);
	this.popinView.callingElement = termElement;
    this.popinView.render(infos);
    this.popinView.show();
};

GlossaryController.prototype.renderTermViews = function () {
    for (var i = 0; i < this.terms.length; i++) {
        var currentTerm = this.terms[i];

        if (!currentTerm.term || !currentTerm.keyword || !currentTerm.definition) {
            continue;
        }
        // Explanation of the regular expression:
        // * Before we had (\b<word>\b), which would match the word with boundaries in the beginning and in the end.
        // This means that it would match the word if it was surrounded by spaces, or if it ended with punctuation (so,
        // basically wold match the word itself). This solution worked great, except when the word started or ended with
        // characters with accents: the \b only works with characters that match with \w, and characters with accents
        // don't match with it;
        // * To fix this problem, this is the new regular expression that we had to use:
        // (\s|^|[\00-\57]|[\72-\100]|[\133-\140|\173-\177])<word>(=?\s|$|[\00-\57]|[\72-\100]|[\133-\140|\173-\177])
        // This regular expression matches with the <word> if it begins with a space, or if it's the beginning of the
        // sentence, or if begins with any of the characters within those ranges (0 to 57, 72 to 100, 133 to 140 or 173 to 177),
        // and if it ends with a space, if it's the end of the sentence, or if it ends with any of the characters within
        // the same ranges. Those ranges are octal indexes of the ASCII table, and are basically punctuation points and
        // some special characters.
        var termToReplace = "(\\s|^|[\\00-\\57]|[\\72-\\100]|[\\133-\\140|\\173-\\177])" + currentTerm.keyword + "(=?\\s|$|[\\00-\\57]|[\\72-\\100]|[\\133-\\140|\\173-\\177])";
        var regex = new RegExp(termToReplace, "gi");
        var normalizedTerm = this.normalizeTerm(currentTerm.term);

        this.element.innerHTML = this.element.innerHTML.replace(regex, "$1" + glossaryTermTemplate(currentTerm.keyword, normalizedTerm) + "$2");
    }
};

GlossaryController.prototype.getTermInfosFrom = function (element) {
    return this.termModel[getTermNameFrom(element)];
};

GlossaryController.prototype.getTermModelFrom = function (terms) {
    var termModel = {};

    for (var i = 0; i < terms.length; i++) {
        var termKey = this.normalizeTerm(terms[i].term);
        termModel[termKey] = {
            keyword: terms[i].keyword,
            definition: terms[i].definition
        };
    }

    return termModel;
};

GlossaryController.prototype.normalizeTerm = function (term) {
    return term.replace(/ .,\/#!$%\^&\*;:{}=\-_`~()"']/g, "").toLowerCase();
};

function getTermNameFrom(element) {
    return element.getAttribute("data-term-key").toLowerCase();
}

function glossaryTermTemplate(termKeyword, normalizedTerm) {
    return (
        "<span data-term-key='" +
        normalizedTerm +
        "' class='dcw_gsm_show-popin js-open-popin' readonly='true'>" +
        termKeyword +
        "</span>"
    );
}

export default GlossaryController;



// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/Glossary/Glossary.controller.js